import React from 'react';
import ThemeToursTemplate from './ThemeToursTemplate';

const PilgrimagePage = () => {
  return <ThemeToursTemplate theme="pilgrimage" />;
};

export default PilgrimagePage;
